import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { CustomerServiceAnalyticsMenuLinkItem } from './ui/index.tsx';

export const CustomerServiceAnalytics = () => (
	<JSErrorBoundary
		fallback="flag"
		id="assets"
		packageName="jiraNavigationAppsSidebarNav4SidebarsContentCustomerService"
		teamName="Kalari"
	>
		<CustomerServiceAnalyticsMenuLinkItem />
	</JSErrorBoundary>
);
